import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';
import type { TableCellProps } from '@mui/material';

export interface DataTableSort {
  active: boolean;
  direction: 'asc' | 'desc';
  onClick: () => void;
}

interface DataTableHeaderCellProps extends Omit<TableCellProps, 'sortDirection'> {
  sort?: DataTableSort;
}

const DataTableHeaderCell: React.FC<DataTableHeaderCellProps> = ({
  children,
  scope = 'col',
  sort,
  ...cellProps
}) => (
  <TableCell {...cellProps} scope={scope} sortDirection={sort?.active ? sort.direction : false}>
    {sort ? (
      <TableSortLabel active={sort.active} direction={sort.direction} onClick={sort.onClick}>
        {children}
      </TableSortLabel>
    ) : children}
  </TableCell>
);

export default DataTableHeaderCell;
